module.exports = __webpack_public_path__ + "img/arh_10.0a727cc3.jpg";